import React, { Component } from "react";

import { connect } from "react-redux";
import * as actions from "./../../actions";

import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';


import MailIcon from '@material-ui/icons/Mail';

import { withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon';

import GoogleIcon from 'mdi-material-ui/Youtube'
import FacebookIcon from 'mdi-material-ui/Facebook'
import InstagramIcon from 'mdi-material-ui/Instagram'

import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";

const styles = theme => ({
  root:{
    padding: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit * 5,
    position: "relative",

    minHeight: 150,
    
    background: theme.palette.background.dark
  },
  title:{
    borderBottom: "1px solid white",
    color: "white",
    marginBottom: theme.spacing.unit,
    fontSize: 15,
  },
  listItemIcon:{
    color: "white",
    fontSize: 13,
  },
  listItem:{
    color: "white",
    fontSize: 13,
    textTransform: "uppercase",
  },

  google:{
    color:"white",
    fontSize: 27,
    background:"#ff0000",
  },
  facebook:{
    color:"white",
    fontSize: 27,
    background: "#3b5998",
  },
  instagram:{
    fontSize: 27,
    background: "#FFFFFF",
  },

})



function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class Footer extends Component{

  state = {
    companyInfoDialog: false,
  }

  static contextTypes = {
    router: PropTypes.object
  }

  toggleCompanyInfoDialog = ()=>{
    this.setState({companyInfoDialog: !this.state.companyInfoDialog})
  }

  render(){
    const {classes, theme} = this.props
    return(
      <div  className={this.props.classes.root} >
        <Dialog

          open={this.state.companyInfoDialog}
          onClose={this.toggleCompanyInfoDialog}
          TransitionComponent={Transition}
        >
          <div style={{ padding: theme.spacing.unit*3}}>

                <Typography variant="title" style={{textAlign:"center"}}>O PODJETJU</Typography>
                <List  >
                  <ListItem style={{flexDirection:"column"}} >
                    <Typography variant="body1"  >
                        Wolf consulting d.o.o.
                    </Typography>
                    <Typography variant="body1"  >
                        Ul.Miše Stupara br. 4, Banja Luka
                    </Typography>
                  </ListItem>
                  <ListItem style={{flexDirection:"column"}} >
                    <Typography variant="body1"  >
                      DAVČNA ŠTEVILKA
                    </Typography>
                    <Typography variant="body1"  >
                      11205208
                    </Typography>
                  </ListItem>
                  <ListItem style={{flexDirection:"column"}} >
                    <Typography variant="body1"  >
                      TRANSAKCIJSKI RAČUN
                    </Typography>
                     
                    <Typography variant="body1"  >
                      BA395620998165666619
                    </Typography>
                  </ListItem>
                </List>

          </div>

        </Dialog>


        <Grid container justify="space-around" spacing={24}>

          <Grid item xs={12}  sm={12} md={3} >
            <Typography variant="body1" className={classes.title}>KONTAKTI</Typography>
            <List dense disablePadding>
              <ListItem >
                <ListItemIcon className={classes.listItemIcon}>
                  <MailIcon />
                </ListItemIcon>
                <Typography variant="body1" className={classes.listItem}>
                  info@betmoneymaker.com
                </Typography>
              </ListItem>
              <ListItem >
                <ListItemIcon className={classes.listItemIcon}>
                  <MailIcon />
                </ListItemIcon>
                <Typography variant="body1" className={classes.listItem}>
                  stavninasvet@gmail.com
                </Typography>
              </ListItem>

            </List>

          </Grid>

          <Grid item xs={12}  sm={12} md={3} >
            <Typography variant="body1" className={classes.title} style={{}}>INFO</Typography>
            <List dense disablePadding>
              <ListItem style={{cursor:"pointer"}}  onClick={()=>this.props.showUserAgreementDialog(true)}>
                <Typography variant="body1"  className={classes.listItem}>
                  Pogoji uporabe
                </Typography>
              </ListItem>
              <ListItem style={{cursor:"pointer"}} onClick={this.toggleCompanyInfoDialog}>
                <Typography variant="body1" className={classes.listItem} >
                  O podjetju
                </Typography>
              </ListItem>
              <ListItem style={{cursor:"pointer"}} >
                <Typography variant="body1" style={{cursor:"pointer"}} onClick={()=>this.props.showCookiesInfo(true)} className={classes.listItem}>
                  Piškotki
                </Typography>
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={12}  sm={12} md={3} style={{display: "flex",flexDirection:"column", justifyContent: "center", alignItems:"center", minHeight: 150}}>

            <div style={{display:"flex", flexDirection: "row", justifyContent: "space-around", width: "100%"}}>
              <IconButton onClick={()=>window.location.replace("https://www.youtube.com/user/BetMoneymaker")} className={classes.google}><GoogleIcon /></IconButton>
              <IconButton onClick={()=>window.location.replace("https://www.facebook.com/bet.moneymaker")} className={classes.facebook}><FacebookIcon style={{fontSize: 20}} /></IconButton>
              <IconButton onClick={()=>window.location.replace("https://www.instagram.com/betmoneymaker/")} className={classes.instagram}><InstagramIcon style={{fontSize: 20}}/></IconButton>

            </div>


          </Grid>
        </Grid>
      </div>
    )
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({ userInfoData }) => {
  return {
    userInfoData
  };
};

export default connect(mapStateToProps, actions)( withStyles(styles, { withTheme: true })(Footer))



// WEBPACK FOOTER //
// ./src/components/main/Footer.js